<div class="form-modal">
  <div class="form-content">
    <div class="form-header">
      <h4 class="form-title" id="exampleModalFullscreenXlLabel">
        <ng-content select="[title]"></ng-content>
      </h4>
      <button type="button" class="btn-close"
              (click)="onClose()"></button>
    </div>
    <div class="form-body">
      <ng-content select="[body]"></ng-content>
    </div>
    <div class="form-footer">
      <div class="d-grid gap-2 d-flex justify-content-end">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  </div>
</div>
